import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../i18n";
import { Trophy, Medal, Award } from "lucide-react";

const icons = { 1: Trophy, 2: Medal, 3: Award };
const accents = { 1: "#FFB703", 2: "#C0C0C0", 3: "#CD7F32" };

export default function Prizes() {
  const { t } = useI18n();
  const [prizes, setPrizes] = useState([]);

  useEffect(() => {
    api.get("/prizes").then((r) => setPrizes(r.data));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="prizes-page">
      <div className="text-[11px] uppercase tracking-[0.3em] font-mono font-bold text-[#00D37F]">
        {t("nav_prizes")} · {t("payout_structure")}
      </div>
      <h1 className="font-display text-5xl sm:text-6xl mt-2">
        {t("win_the")} <span className="text-[#FFB703]">{t("trophy")}</span>
      </h1>
      <p className="text-sm text-white/50 mt-2 mb-10 font-mono">{t("prizes_subtitle")}</p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {prizes.map((p) => {
          const Icon = icons[p.position] || Trophy;
          const accent = accents[p.position] || "#007AFF";
          return (
            <div
              key={p.id}
              className="border border-white/10 bg-[#0d0d0d] hover:border-[#FFB703]/40 transition-colors overflow-hidden fade-up"
              data-testid={`prize-card-${p.id}`}
            >
              {p.image_url && (
                <div
                  className="h-56 bg-cover bg-center relative"
                  style={{ backgroundImage: `url('${p.image_url}')` }}
                >
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d] via-transparent to-transparent" />
                </div>
              )}
              <div className="p-6">
                <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-[0.3em] font-bold" style={{ color: accent }}>
                  <Icon className="w-4 h-4" />
                  <span>
                    {t("pos_short")} #{p.position} · {p.position === 1 ? t("first_place") : p.position === 2 ? t("second_place") : p.position === 3 ? t("third_place") : ""}
                  </span>
                </div>
                <h3 className="font-display text-3xl mt-3">{p.title}</h3>
                <p className="text-sm text-white/60 mt-3 leading-relaxed">{p.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
